import React, { useEffect } from "react";

export default function FormHosb() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.charset = "utf-8";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "46247220",
          formId: "4dd833be-9519-4e46-aee1-d5cbacd4064b",
          region: "na1",
          target: "#hs-form",
        });
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="border border-sidom-orange bg-sidom-gray  text-sidom-light rounded-xl py-20 px-4 sm:px-8 lg:px-16">
      <div className="max-w-4xl mx-auto ">
        <div id="hs-form" className="hubspot-form-custom text-sidom-light  " />
      </div>
    </section>
  );
}
